import { QA_ATTEMPTS } from '@aloft/toolkit-shared';
import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { usePostQaAttempt } from '../../hooks/api/schema-hooks/usePostQaAttempt.ts';
import { useUploadQAFiles } from '../../modules/qaBeta/hooks/useUploadQAFiles.ts';
import { QAUploadDocumentsForm } from '../../modules/qaBeta/schemas.ts';
import { QaAttempt } from '../../modules/qaBeta/types.ts';

type StartQAParams = { orderID: string; files: QAUploadDocumentsForm };
type StartQAOptions = UseMutationOptions<QaAttempt, unknown, StartQAParams>;

export function useStartQA(options: StartQAOptions) {
  const { mutateAsync: uploadQAFiles } = useUploadQAFiles();
  const { mutateAsync: postQAAttempt } = usePostQaAttempt();

  const startQA = async (params: StartQAParams) => {
    const { orderID, files } = params;

    const blobs = await uploadQAFiles({
      reportPDF: files.reportPDF,
      orderDetailsPDF: files.orderDetailsPDF,
      loePDF: files.loePDF,
      purchaseContractPDF: files.purchaseContractPDF,
    });

    const qaAttempt = await postQAAttempt({
      pathParams: { orderID },
      body: QA_ATTEMPTS.POST.REQUEST.BODY.parse({
        files: {
          reportPDF: blobs.reportPDF,
          orderDetailsPDF: blobs.orderDetailsPDF,
          loePDF: blobs.loePDF,
          purchaseContractPDF: blobs.purchaseContractPDF,
        },
      }),
    });

    return qaAttempt;
  };

  return useMutation({ ...options, mutationFn: startQA });
}
